import { render } from "./YoubeCatalogo.vue?vue&type=template&id=7098eb8c&scoped=true"
import script from "./YoubeCatalogo.vue?vue&type=script&lang=js"
export * from "./YoubeCatalogo.vue?vue&type=script&lang=js"

import "./YoubeCatalogo.vue?vue&type=style&index=0&id=7098eb8c&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7098eb8c"]])

export default __exports__